module.exports = __webpack_public_path__ + "assets/chartpack.ff0eb948.svg";